/**
 * Encode literal spaces in a client-side navigation path so space-bearing pages
 * resolve on the FIRST click.
 *
 * Several pages have spaces in their names -- the nav's `/Field Sets`,
 * `/Team Members`, `/Service Requests`, and the Select-List pages (`/Case Types`,
 * `/Location Types`, ...). Nuxt registers those routes ENCODED
 * (`/Field%20Sets`), and Vue Router 4 matches a client-side `router.push` against
 * the encoded record. So a raw `router.push('/Field Sets')` -- which is what a
 * `<v-list-item :to="'/Field Sets'">`, a breadcrumb, or a row-click page-push all
 * issue -- matches NOTHING and lands on the 404 page. (A full page load works
 * only because the browser encodes the address-bar URL before Vue Router sees it;
 * hence "first click 404s, the second works".)
 *
 * A single global guard fixes every source at once: if a navigation's path
 * carries a literal space, redirect to the %20-encoded path, which then matches.
 * Done as a space-only replace rather than `encodeURI` so a path that is already
 * partly encoded is never double-encoded (`%20` -> `%2520`).
 *
 * Runs after Nuxt's middleware guards, which is fine: an authenticated user
 * hitting the (unmatched) raw path isn't blocked, so this guard's redirect fires
 * and re-runs the chain on the valid encoded path.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  router.beforeEach((to) => {
    if (to.path.includes(' ')) {
      return {
        path: to.path.replace(/ /g, '%20'),
        query: to.query,
        hash: to.hash,
      }
    }
  })
})
